import { Link } from "react-router-dom";
import { getHeadline } from "@/lib/articles";
import { siteInfo } from "@/mocks/site";

export default function TimelineSection() {
  const headline = getHeadline();

  return (
    <section className="bg-secondary-900 px-4 py-14 md:px-6 md:py-20" aria-label="事件追踪时间线">
      <div className="shell grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-14">
        <div className="lg:col-span-1">
          <span className="inline-flex items-center gap-2 text-xs font-label font-bold uppercase tracking-[0.2em] text-accent-300">
            <span className="h-px w-6 bg-accent-400" aria-hidden="true" />
            Tracking
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
            事件追踪时间线
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            每条爆料从出现到落地，中间会有多个关键节点。我们把它们按时间排好，你不需要翻遍全网，也能看清事情是怎么一步步走到今天的。
          </p>

          <div className="mt-8 space-y-3">
            {siteInfo.reliabilityLegend.map((item) => (
              <div key={item.key} className="flex items-start gap-3">
                <span className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-accent-400" aria-hidden="true" />
                <p className="text-sm text-background-200">
                  <span className="font-label font-bold text-background-50">{item.key}</span>
                  <span className="mx-1.5 text-background-50/30">·</span>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <Link
            to={`/article/${headline.slug}`}
            className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-label font-bold text-secondary-900 transition-colors hover:bg-accent-300"
          >
            查看当前追踪事件
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="lg:col-span-2">
          <div className="rounded-lg border border-background-50/12 bg-background-50/5 p-5 md:p-7">
            <div className="mb-6 flex flex-wrap items-center gap-3 border-b border-background-50/12 pb-5">
              <i className="ri-live-line text-lg text-primary-400" aria-hidden="true" />
              <span className="text-[11px] font-label font-bold uppercase tracking-[0.15em] text-primary-300">
                追踪中
              </span>
              <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">{headline.title}</h3>
            </div>

            <ol className="relative space-y-7 border-l border-background-50/15 pl-6">
              {headline.timeline.map((node, index) => (
                <li key={node.time} className="relative">
                  <span
                    className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full ${
                      index === headline.timeline.length - 1
                        ? "bg-primary-500 ring-4 ring-primary-500/20"
                        : "bg-background-50/25"
                    }`}
                    aria-hidden="true"
                  />
                  <span className="block text-[11px] font-label font-bold tracking-wide text-accent-300">
                    {node.time}
                  </span>
                  <h4 className="mt-1.5 font-heading text-base font-bold text-background-50">{node.title}</h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-background-300">{node.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}